module.exports = __webpack_public_path__ + "img/001-gorilla.1ae61f74.svg";